import { noop } from '@saaga/shared/utils/noop.util.ts'
import type {
  AgentItemActions,
  ChatItemActions,
  ProjectItemActions,
} from './sidebar-item-actions.interface'

export const createDefaultChatActions = (): ChatItemActions => ({
  onShare: noop,
  onRename: noop,
  onPin: noop,
  onArchive: noop,
  onDelete: noop,
})

export const createDefaultProjectActions = (): ProjectItemActions => ({
  onShare: noop,
  onRename: noop,
  onDelete: noop,
})

export const createDefaultAgentActions = (): AgentItemActions => ({
  onMakeCopy: noop,
  onPin: noop,
  onRename: noop,
  onDelete: noop,
})
